import { useState, useEffect } from 'react';

import { BarChart } from "./UI";

export default function Periods ({analytics}) {

    const [barChart, setBarChart] = useState([]);

    const graphHours = () => {

		let hours = [
			{ name: "0", value: 0 },
			{ name: "3", value: 0 },
			{ name: "6", value: 0 },
			{ name: "9", value: 0 },
			{ name: "12", value: 0 },
			{ name: "15", value: 0 },
			{ name: "18", value: 0 },
            { name: "21", value: 0 },
		];

		for (let key in analytics) {

			let item = analytics[key];

			//console.log(key);
			//console.log(item);

			if (item.timestamp.seconds) {

				//console.log('#');

				//console.log(item.user_id + ' ' + formatDateTime(item.timestamp.seconds) + ' ' + item.timestamp.seconds);
				//console.log(hour);

				var a = new Date(item.timestamp.seconds * 1000);
				var hour = a.getHours();

				if 	  (hour >= 0 && hour < 3)	hours[0]['value'] += 1;
				else if (hour >= 3 && hour < 6)	hours[1]['value'] += 1;
				else if (hour >= 6 && hour < 9)	hours[2]['value'] += 1;
				else if (hour >= 9 && hour < 12)	hours[3]['value'] += 1;
				else if (hour >= 12 && hour < 15)	hours[4]['value'] += 1;
				else if (hour >= 15 && hour < 18)	hours[5]['value'] += 1;
				else if (hour >= 18 && hour < 21)	hours[6]['value'] += 1;
				else if (hour >= 21 && hour <= 24)hours[7]['value'] += 1;


			}

			//console.log(hours);

		}
		setBarChart(hours);
	}

      useEffect(() => {

        graphHours();

    }, [analytics]);

    return (

        <div className="">

			<div className="title">Peak periods</div>
			{/*
			<div className="tabs">
				<div className="active">Time</div>
				<div>Days</div>
			</div>
			*/}
			<BarChart data={barChart} height="148" />

		</div>
    )
}
